import { apiYclickMaster } from './api';

export const getUsersService = (value) =>
  apiYclickMaster.get(`/v1/Usuarios/all?fullName=${value}`);

export const getRoleUserCERTService = () =>
  apiYclickMaster.get('/v1/Roles/me?modulo=CERT');

export const getRolePermissionsCERTService = () =>
  apiYclickMaster.get('/v1/Roles/permissions?modulo=CERT');

export const getRoleUserSERVService = () =>
  apiYclickMaster.get('/v1/Roles/me?modulo=SERV');

export const getRolePermissionsSERVService = () =>
  apiYclickMaster.get('/v1/Roles/permissions?modulo=SERV');

  export const getRoleUserADMService = () =>
  apiYclickMaster.get('/v1/Roles/me?modulo=ADM');

export const getRolePermissionsADMService = () =>
  apiYclickMaster.get('/v1/Roles/permissions?modulo=ADM');
  
export const getUserProvider = () => apiYclickMaster.get('/v1/Usuarios/proveedor/me');
